import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center bg-red-700 h-14 text-white text-2xl px-5" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "w-[99px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, "Prototyp Internal use")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 flex justify-end" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-2xl mr-4" }, "Price indication tool")
], -1)

import Icons from "@/components/Icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Icons), { name: "3s-logo" })
      ])
    ]),
    _hoisted_4,
    _hoisted_5
  ]))
}
}

})